/* =============================================================================
   TONEE TUMMY — SHOPIFY PRODUCT TEMPLATE BEHAVIOUR (product.liftform-tummy.liquid)
   -----------------------------------------------------------------------------
   Adapted from a standalone recreation of toneeskin.com/products/tonee-tummy.
   Vanilla JS, no dependencies. Everything is namespaced in an IIFE and each
   feature is initialised independently so a missing block never breaks the rest.

     01. Gallery      — main image swap, thumbnail state, prev/next, swipe
     02. Bundle       — quantity/pack selector (static design element for now,
                         does not drive cart quantity or the price row)
     03. Accordions   — description tabs + FAQ (single shared component)
     04. Delivery     — live "Estimated delivery between X - Y" date range

   Real add-to-cart is handled by the theme's own product-form.js custom
   element (wired up in the template markup), not by this file. The mobile
   nav toggle from the original standalone mockup is dropped too: this page
   renders inside the theme's normal header/footer, which has its own nav.
   ============================================================================= */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
     01. GALLERY
     Clicking a thumbnail (or an arrow) swaps the main image. The thumbnails
     use aria-current="true" for the active outline so the CSS stays declarative.
  ---------------------------------------------------------------------------- */
  function initGallery() {
    var main   = document.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(
      document.querySelectorAll('[data-gallery-thumb]')
    );
    if (!main || !thumbs.length) return;

    var index = 0;

    function show(i) {
      // wrap around at both ends
      index = (i + thumbs.length) % thumbs.length;

      var src = thumbs[index].getAttribute('data-src');
      var alt = thumbs[index].getAttribute('data-alt') || '';
      main.setAttribute('src', src);
      main.setAttribute('alt', alt);

      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
    });

    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    // Keyboard arrows when the gallery has focus
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });

    // Basic touch swipe on the main image
    var startX = null;
    main.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });

    show(0);
  }


  /* ---------------------------------------------------------------------------
     02. BUNDLE / QUANTITY SELECTOR
     Static design element for now: selecting a card only updates the visual
     aria-checked / "selected" state. It does NOT change the real cart
     quantity or rewrite the live price row above, since the product form
     always adds the single selected variant at quantity 1 regardless of
     which pack card is highlighted.
  ---------------------------------------------------------------------------- */
  function initBundle() {
    var options = Array.prototype.slice.call(
      document.querySelectorAll('[data-bundle-option]')
    );
    if (!options.length) return;

    function select(option) {
      options.forEach(function (o) {
        o.setAttribute('aria-checked', o === option ? 'true' : 'false');
      });
    }

    options.forEach(function (o) {
      o.addEventListener('click', function () { select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(o);
        }
      });
    });

    // Default selection: whichever card is flagged, else the first
    var preset = options.filter(function (o) {
      return o.getAttribute('aria-checked') === 'true';
    })[0];
    select(preset || options[0]);
  }


  /* ---------------------------------------------------------------------------
     03. ACCORDIONS
     Used by both the product description tabs and the FAQ list. Each group can
     opt into "one open at a time" via data-accordion-single on the container.
  ---------------------------------------------------------------------------- */
  function initAccordions() {
    var groups = Array.prototype.slice.call(
      document.querySelectorAll('[data-accordion]')
    );

    groups.forEach(function (group) {
      var single = group.hasAttribute('data-accordion-single');
      var items  = Array.prototype.slice.call(
        group.querySelectorAll('.accordion-item')
      );

      items.forEach(function (item) {
        var header = item.querySelector('.accordion-header');
        if (!header) return;

        header.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          if (single) {
            items.forEach(function (other) {
              other.classList.remove('is-open');
              var h = other.querySelector('.accordion-header');
              if (h) h.setAttribute('aria-expanded', 'false');
            });
          }

          item.classList.toggle('is-open', willOpen);
          header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });
    });
  }


  /* ---------------------------------------------------------------------------
     04. DELIVERY ESTIMATE
     Keeps the "Estimated delivery between X - Y" range live: today + 4 to
     today + 6 days, recalculated on every page load.
  ---------------------------------------------------------------------------- */
  function initDelivery() {
    var el = document.querySelector('[data-delivery-range]');
    if (!el) return;

    var fmt = function (d) {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };
    var from = new Date(); from.setDate(from.getDate() + 4);
    var to   = new Date(); to.setDate(to.getDate() + 6);

    el.textContent = fmt(from) + ' - ' + fmt(to);
  }


  /* --------------------------------------------------------------------------- */
  function init() {
    initGallery();
    initBundle();
    initAccordions();
    initDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
